export default __webpack_public_path__ + "static/media/BreachConnectLogoSidebar.9b971b01.png";